<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { PRICES } from '@presentation/Types/Settings';
import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';

const presentation = usePresentation();

</script><template>

    <Page>

        <div class="grid grid-cols-12 justify-center items-center gap-16 w-full">

            <div class="col-span-6">

                <div class="mb-1 text-lg 4xl:text-2xl text-white text-center font-semibold">Real benefits for your customers</div>
                <div class="mb-6 text-xs 4xl:text-base text-white text-center">Covered Items Limits (Per Work Order) Parts and Labour excluding GST</div>

                <table class="
                    uppercase text-xs 2xl:text-sm 3xl:text-base text-center w-full 
                    border-separate rounded-lg ring-4 ring-white shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold text-xs">
                            <td class="bg-indigo-600 rounded-tl-lg p-1 lg:p-2 text-left">Item</td>
                            <td class="bg-indigo-600 p-1 md:p-4">Cat<br/>1</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>2</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>3</td>
                            <td class="bg-indigo-600 rounded-tr-lg p-1 md:p-4">Cat<br/>4</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Key Fob Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $880
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $580
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,000
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Brake Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $500
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $485
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $920
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Wiper Blades
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $86
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $81
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $92
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $194
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Battery Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $340
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $340
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $555
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Repair
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $36
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $36
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $42
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $54
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Replacement (per tyre)
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $290
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $290
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $355
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,000
                            </td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-xs 2xl:text-sm">
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2 text-left leading-tight">Max claim amount<br/>over 3 year contract</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2">$6,322</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2 border-gray-950">$5,087</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2  border-gray-950">$8,159</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2">$11,581</td>
                        </tr>

                    </tbody>

                </table>

                <div class="mt-6 text-xs 2xl:text-base text-white text-center">What's in it for your customers</div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

            <div class="col-span-6">

                <div class="mb-1 text-lg 4xl:text-2xl text-white text-center font-semibold">Real benefits for your dealership</div>
                <div class="mb-6 text-xs 4xl:text-base text-white text-center">Potential Labour rate per item, per category, per policy</div>

                <table class="
                    uppercase text-xs md:text-sm 2xl:text-base 3xl:text-lg text-center w-full 
                    border-separate rounded-lg ring-4 ring-white shadow-xl">
            
                    <tbody>
                        <tr class="font-semibold text-xs">
                            <td class="bg-indigo-600 rounded-tl-lg p-1 lg:p-2 text-left">Item</td>
                            <td class="bg-indigo-600 p-1 md:p-4">Cat<br/>1</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>2</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>3</td>
                            <td class="bg-indigo-600 rounded-tr-lg p-1 md:p-4">Cat<br/>4</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Key Fob Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $720
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $720
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $840
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,080
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Brake Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $720
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $720
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $840
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $1,080
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Wiper Blades
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $72
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $72
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $84
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $108
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Battery Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $90
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $90
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $105
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $135
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Repair
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $216
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $216
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $252
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $324
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm text-left">
                                Tyre Replacement (per tyre)
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $360
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $360
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $420
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-xs 3xl:text-sm">
                                $540
                            </td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-xs 2xl:text-sm">
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2 text-left leading-tight">Additional profit<br/>from work orders</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2">$2,178</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2 border-gray-950">$2,178</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2  border-gray-950">$2,541</td>
                            <td class="bg-gray-200 text-indigo-500 p-1 lg:p-2">$3,267</td>
                        </tr>
                    </tbody>
                </table>

                <div class="mt-6 text-xs 2xl:text-base text-white text-center">What's in it for <span class="uppercase font-semibold text-cyan-500">your</span> bottom line</div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

        </div>


    </Page>

</template>